<div class="container">
  <h2>Institutional Account</h2>
  <ul>
      <li>
          <a routerLink="iact-definition" title="Definition of Institutional Account">
              Definition of
              Institutional Account
          </a>
      </li>
      <li><a [routerLink]="['iact-list', 'byNumber']" title="Institutional Account List">Institutional Account List</a></li>
      <li>
        <a href="https://cam.fo.uiowa.edu/news/2023/11/iaccts-acquisitions-equipment-software-and-leases" title="Acquisitions of Equipment, Software, and Leases" target="_blank">
            Acquisitions of Equipment, Software, and Leases
        </a>
      </li>
      <li>Chart of Accounts</li>
      <ul>
          <li *ngFor="let iacctRange of iacctRanges">
              <a [routerLink]="['iact-list', iacctRange.rangeId]" [title]="iacctRange.rangeName">
                  {{iacctRange.rangeStart}} -
                  {{iacctRange.rangeEnd}} <span class="iacct-item">{{iacctRange.rangeName}}</span>
              </a>
          </li>
      </ul>
      <li>Related Memos</li>
      <ul>
          <li>
              <a href="https://afr.fo.uiowa.edu/changes-institutional-accounts-may-2017" title="Changes in Institutional Accounts (May 2017) " target="_blank">
                  Changes in Institutional Accounts (May 2017)
              </a>
          </li>
          <li>
              <a href="https://afr.fo.uiowa.edu/changes-institutional-accounts-july-2015" title="Changes in Institutional Accounts (July 2015)" target="_blank">
                  Changes in Institutional Accounts (July 2015)
              </a>
          </li>
          <li>
              <a href="http://afr.fo.uiowa.edu/tuition-support-grad-students-notice-april-21-2015" title="Tuition Support for Grad Students Notice (April 21, 2015)" target="_blank">
                  Tuition Support for Grad Students Notice (April 21, 2015)
              </a>
          </li>
          <li>
              <a href="https://afr.fo.uiowa.edu/new-institutional-accounts-track-it-equipment-services-april-1-2014" title="New Institutional Accounts to Track IT Equipment & Services (April 1, 2014)" target="_blank">
                  New Institutional Accounts to Track IT Equipment & Services (April 1, 2014)
              </a>
          </li>
      </ul>
  </ul>
</div>